<template>
    <div class="DropdownsExample">
        <ComponentPlayground
            :component="NewDropdown"
            :defaults="singleDefaults"
            :event-bindings="{ change: 'selected' }"
            title="NewDropdown — Single Select"
            description="Single-select dropdown. Edit the &quot;options&quot; JSON to add {&quot;disable&quot;: true}."
        />
        <ComponentPlayground
            :component="NewDropdown"
            :defaults="multiDefaults"
            :event-bindings="{ change: 'selected' }"
            title="NewDropdown — Multi Select"
            description="Multi-selection with Select All / Cancel / Apply. Lower minOptionsForFilter to enable search."
        />
        <ComponentPlayground
            :component="NewCustomDropdown"
            :defaults="customDefaults"
            :prop-custom-type-labels="{
                positionX: 'string => start | end',
                positionY: 'string => bottom | top',
            }"
            title="NewCustomDropdown"
            :description="customDropdownDesc"
        />
    </div>
</template>

<style lang="scss" scoped>
.DropdownsExample {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    max-width: 56rem;
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { NewDropdown } from '@evidentid/dashboard-commons/components/Dropdown';
    import NewCustomDropdown from '@evidentid/dashboard-commons/components/Dropdown/NewCustomDropdown.vue';
    import { DropdownOption } from '@evidentid/dashboard-commons/components/Dropdown/types';

    import ComponentPlayground from './ComponentPlayground.vue';

    const BASE_OPTIONS: DropdownOption[] = [
        { label: 'Option 1', value: 'option-1' },
        { label: 'Option 2', value: 'option-2' },
        { label: 'Option 3', value: 'option-3' },
        { label: 'Option 4', value: 'option-4' },
        { label: 'Option 5', value: 'option-5' },
    ];

    export default defineComponent({
        name: 'DropdownsExample',
        components: { ComponentPlayground },
        data() {
            return {
                NewDropdown,
                NewCustomDropdown,
                customDropdownDesc: 'Unlike NewDropdown (Quasar QSelect, single + multi-select), this wraps a custom' +
                    ' Popover + QVirtualScroll and is single-select only with built-in search. Use it instead when' +
                    ' you need full control over trigger/item rendering via slots, explicit popover positioning' +
                    ' (positionX/Y, autoFlip), or portal/teleport support.',
                singleDefaults: {
                    label: 'Select an option',
                    options: BASE_OPTIONS,
                    selected: undefined as DropdownOption | undefined,
                    disabled: false,
                    hideLabelWhenHasValue: true,
                    noEllipsis: false,
                    minOptionsForFilter: 10,
                },
                multiDefaults: {
                    label: 'Select options',
                    options: BASE_OPTIONS,
                    selected: [] as DropdownOption[],
                    multiSelect: true,
                    disabled: false,
                    hideSelectAll: false,
                    minOptionsForFilter: 10,
                },
                customDefaults: {
                    items: BASE_OPTIONS,
                    triggerLabel: 'Select option',
                    enableSearch: true,
                    closeOnSelect: true,
                    maxHeight: 300,
                    positionX: 'start' as 'start' | 'end',
                    positionY: 'bottom' as 'top' | 'bottom',
                },
            };
        },
    });
</script>
